import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../../../shared-components';
import Feeds from '../Feeds';
import FeedComments from '../feed-comments';
import { Loader } from '../../../shared-components';
import {
  ALL,
  NEGATIVE,
  NEUTRAL,
  POSITIVE,
  JOY,
  ANGER,
  SADNESS,
  FEAR,
  GROUP_BY_SENTIMENT_STATE,
  GROUP_BY_EMOTION_STATE,
  GROUP_BY_BUTTON_LABEL,
  COMMENT_SORT_OPTIONS,
  SORT_BY_BUTTON_LABEL
} from '../../redux/constants';
import DropdownSelection from './DropdownSelection';
import DropdownFilter from './DropdownFilter';
import ControversyIndicesGrid from '../../../harmwatch/components/ControversyIndicesGrid';
import PieChartForFeedModal from '../../../shared-components/chart/PieChartForFeedModal';

const DATA = 'data';
const SENTIMENT = 'sentiment';
const EMOTION_COUNTS = 'emotionCounts';
const RELEVANT_COMMENT_COUNT = 'relevantCommentCount';
const FILTERED_COMMENT_COUNT = 'filteredCommentCounts';

const neutralIndexInSentimentMap = 2
const positiveIndexInSentimentMap = 0
const negativeIndexInSentimentMap = 1
const decPlaces = 2

const FeedDetails = React.memo(
  ({
    show,
    toggleFeedDetails,
    feed,
    activeFeedCategory,
    feedDetails,
    loadMoreFeedDetails,
    retrieveSelectedSentimentFeedDetails,
    updateRelevance,
    updateRelevanceFeed,
    updateCrawledCommentsIsSarcasmManuallyToggled,
    cookies,
    topicKeywordsJSON,
    groupFeedModalCommentsBy,
    sortFeedModalCommentsBy,
    handleCommentsGroupByInFeedModalChange,
    handleCommentsSortByInFeedModalChange,
    feedModalMinimumSarcasmScore,
    feedModalMaximumSarcasmScore,
    setFeedModalSarcasmScoreFilter,
    isHarmWatchTab
  }) => {
    FeedDetails.propTypes = {
      isHarmWatchTab: PropTypes.bool.isRequired,
      feed: PropTypes.object.isRequired,
      setFeedModalSarcasmScoreFilter: PropTypes.func,
      updateCrawledCommentsIsSarcasmManuallyToggled: PropTypes.func.isRequired
    };
    const [responseType, toggleResponseType] = useState(POSITIVE);
    const [isLoader, setLoaderActive] = useState(false);
    const [filteredCommentCounts, setFilteredCommentCounts] = useState({
      [ALL]:      feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][ALL] : feed[RELEVANT_COMMENT_COUNT],
      [POSITIVE]: feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][POSITIVE] : feed[SENTIMENT][positiveIndexInSentimentMap].total,
      [NEGATIVE]: feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][NEGATIVE] : feed[SENTIMENT][negativeIndexInSentimentMap].total,
      [NEUTRAL]:  feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][NEUTRAL] : feed[SENTIMENT][neutralIndexInSentimentMap].total,
      [JOY]:      feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][JOY] : feed[EMOTION_COUNTS][JOY],
      [ANGER]:    feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][ANGER] : feed[EMOTION_COUNTS][ANGER],
      [SADNESS]:  feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][SADNESS] : feed[EMOTION_COUNTS][SADNESS],
      [FEAR]:     feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][FEAR] : feed[EMOTION_COUNTS][FEAR]
    });
    useEffect(() => {
      document.body.classList.add('modal-open');
      toggleResponseType(activeFeedCategory);
      return () => {
        document.body.classList.remove('modal-open');
      };
    }, [show]);
    useEffect(() => {
      if (feedDetails[DATA]) {
        setFilteredCommentCounts({
          [ALL]:      feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][ALL] : feed[RELEVANT_COMMENT_COUNT],
          [POSITIVE]: feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][POSITIVE] : feed[SENTIMENT][positiveIndexInSentimentMap].total,
          [NEGATIVE]: feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][NEGATIVE] : feed[SENTIMENT][negativeIndexInSentimentMap].total,
          [NEUTRAL]:  feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][NEUTRAL] : feed[SENTIMENT][neutralIndexInSentimentMap].total,
          [JOY]:      feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][JOY] : feed[EMOTION_COUNTS][JOY],
          [ANGER]:    feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][ANGER] : feed[EMOTION_COUNTS][ANGER],
          [SADNESS]:  feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][SADNESS] : feed[EMOTION_COUNTS][SADNESS],
          [FEAR]:     feedDetails[FILTERED_COMMENT_COUNT] ? feedDetails[FILTERED_COMMENT_COUNT][FEAR] : feed[EMOTION_COUNTS][FEAR]
        });
      }
    }, [feedDetails[FILTERED_COMMENT_COUNT], feed[SENTIMENT], feed[EMOTION_COUNTS]])
    const setResponseType = type => {
      if (responseType !== type) {
        toggleResponseType(type);
        retrieveSelectedSentimentFeedDetails(type);
      }
    };
    const handleLoadMore = () => {
      setLoaderActive(true);
      loadMoreFeedDetails();
      setTimeout(() => {
        setLoaderActive(false);
      }, 2000);
    };

    function numberConverter(number, decPlaces) {
      decPlaces = Math.pow(10, decPlaces);
      var abbrev = ['K', 'M', 'B', 'T'];
      for (var i = abbrev.length - 1; i >= 0; i--) {
        var size = Math.pow(10, (i + 1) * 3);
        if (size <= number) {
          number = Math.round((number * decPlaces) / size) / decPlaces;
          if (number === 1000 && i < abbrev.length - 1) {
            number = 1;
            i++;
          }
          number += abbrev[i];
          break;
        }
      }
      return number;
    }
    function handleFeedDetails() {
      return;
    }
  
    function handleGroupByModalChange (groupBySelection) {
      handleCommentsGroupByInFeedModalChange(groupBySelection);
      setResponseType(ALL);
    }

    function returnCommentTabs() {
      if (groupFeedModalCommentsBy === GROUP_BY_EMOTION_STATE) {
        return returnEmotionsCommentTabs();
      }
      else {
        return returnSentimentsCommentTabs();
      }
    }

    function returnEmotionsCommentTabs() {
      return (
        <ul>
          <li
            onClick={() => setResponseType(ALL)}
            className={`${responseType === ALL ? 'active' : ''}`}
          >
            All ({numberConverter(filteredCommentCounts[ALL], decPlaces)})
          </li>
          <li
            onClick={() => setResponseType(JOY)}
            className={`${responseType === JOY ? 'active' : ''}`}
          >
            Joy ({numberConverter(filteredCommentCounts[JOY], decPlaces)})
          </li>
          <li
            onClick={() => setResponseType(ANGER)}
            className={`${responseType === ANGER ? 'active' : ''}`}
          >
            Anger ({numberConverter(filteredCommentCounts[ANGER], decPlaces)})
          </li>
          <li
            onClick={() => setResponseType(SADNESS)}
            className={`${responseType === SADNESS ? 'active' : ''}`}
          >
            Sadness ({numberConverter(filteredCommentCounts[SADNESS], decPlaces)})
          </li>
          <li
            onClick={() => setResponseType(FEAR)}
            className={`${responseType === FEAR ? 'active' : ''}`}
          >
            Fear ({numberConverter(filteredCommentCounts[FEAR], decPlaces)})
          </li>
          <li
            onClick={() => setResponseType(NEUTRAL)}
            className={`${responseType === NEUTRAL ? 'active' : ''}`}
          >
            No Specific Emotion ({numberConverter(filteredCommentCounts[NEUTRAL], decPlaces)})
          </li>
        </ul>
      );
    }
    
    function returnSentimentsCommentTabs() {
      return (
        <ul>
          <li
            onClick={() => setResponseType(ALL)}
            className={`${responseType === ALL ? 'active' : ''}`}
          >
            All ({numberConverter(filteredCommentCounts[ALL], decPlaces)})
          </li>
          <li
            onClick={() => setResponseType(POSITIVE)}
            className={`${responseType === POSITIVE ? 'active' : ''}`}
          >
            Positive ({numberConverter(filteredCommentCounts[POSITIVE], decPlaces)})
          </li>
          <li
            onClick={() => setResponseType(NEGATIVE)}
            className={`${responseType === NEGATIVE ? 'active' : ''}`}
          >
            Negative ({numberConverter(filteredCommentCounts[NEGATIVE], decPlaces)})
          </li>
          <li
            onClick={() => setResponseType(NEUTRAL)}
            className={`${responseType === NEUTRAL ? 'active' : ''}`}
          >
            Neutral ({numberConverter(filteredCommentCounts[NEUTRAL], decPlaces)})
          </li>
        </ul>
      );
    }

    function retrieveGroupByDropdownOption() {
      if (groupFeedModalCommentsBy === GROUP_BY_SENTIMENT_STATE){
          return [GROUP_BY_EMOTION_STATE];
      }
      else {
          return [GROUP_BY_SENTIMENT_STATE];
      }
    }

    function retrieveSortByDropdownOptions() {
      let dropdownOptions = COMMENT_SORT_OPTIONS.slice();
      const indexOfSortOptionToRemove = dropdownOptions.indexOf(sortFeedModalCommentsBy);
      if (indexOfSortOptionToRemove > -1) {
        dropdownOptions.splice(indexOfSortOptionToRemove, 1);
      }
      return dropdownOptions;
    }

    function returnFeedTotalCommentsHeader() {
      let commentsLabel = " Comments";
      if (feed.relevantCommentCount == 1) {
        commentsLabel = " Comment";
      }
      return String(feed.relevantCommentCount) + commentsLabel;
    }

    function returnFeedCommentsModalBody() {
      return (
        <div>
          <div className="modal-buttons-row-container">
            <DropdownSelection
              selectedOption={groupFeedModalCommentsBy}
              handleSelectionChange={e => handleGroupByModalChange(e)}
              dropdownOptions={retrieveGroupByDropdownOption()}
              buttonLabel={GROUP_BY_BUTTON_LABEL}
            />
            <DropdownSelection
              selectedOption={sortFeedModalCommentsBy}
              handleSelectionChange={e => handleCommentsSortByInFeedModalChange(e)}
              dropdownOptions={retrieveSortByDropdownOptions()}
              buttonLabel={SORT_BY_BUTTON_LABEL}
            /> 
            <DropdownFilter
              minimumSarcasmScore={feedModalMinimumSarcasmScore}
              maximumSarcasmScore={feedModalMaximumSarcasmScore}
              setFeedModalSarcasmScoreFilter={(e,f) => setFeedModalSarcasmScoreFilter(e,f)}
            /> 
          </div>
          <div className="toggle-response">
            {returnCommentTabs()}
          </div>
          <div className="response-slide-in pr-2">
            <ul>
              <li>
                <div className="feed-comments feed-details-container">
                  {!feedDetails[DATA] && <Loader />}
                  {feedDetails[DATA] &&
                    feedDetails[DATA].length > 0 &&
                    feedDetails.data.map((feed, index) => (
                      <FeedComments
                        userComment={feed}
                        key={feed.commentId}
                        isFeedModal={true}
                        updateRelevance={e => updateRelevance(e)}
                        updateCrawledCommentsIsSarcasmManuallyToggled={e => updateCrawledCommentsIsSarcasmManuallyToggled(e)}
                        cookies={cookies}
                        isHarmWatchTab={isHarmWatchTab}
                      />
                    ))}
                </div>
              </li>
            </ul>
          </div>
        </div>
      );
    }

    function returnModalFooter() {
      return (
        <div className="modal-footer">
          {feedDetails.count &&
            feedDetails.data &&
            feedDetails.count > feedDetails.data.length && (
              <button
                className={`btn btn-loadmore ${isLoader ? 'disabled' : ''}`}
                onClick={handleLoadMore}
              >
                {isLoader ? (
                  <React.Fragment>
                    <i className="la la-spinner la-spin" /> Loading
                  </React.Fragment>
                ) : (
                  'LOAD MORE'
                )}
              </button>
            )}
        </div>
      );
    }
    
    function returnFeedModalForResonanceDashboard() {
      return (
        <Modal handleClick={() => toggleFeedDetails(false)}>
          <div className={`modal feed-details-modal ${show ? 'modal-show' : 'modal-hide'}`}>
            {show && (
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4
                      className="modal-title"
                      dangerouslySetInnerHTML={{ __html: feed.feedTitle }}
                      title={feed.feedTitle}
                    />
                    <i className="la la-close modal-close" onClick={() => toggleFeedDetails(false)} />
                  </div>
                  <div className="modal-body py-0">
                    <Feeds
                      feed={feed}
                      isFeedModal={true}
                      updateRelevanceFeed={e => updateRelevanceFeed(e)}
                      handleFeedDetails={() => handleFeedDetails()}
                      cookies={cookies}
                      topicKeywordsJSON={topicKeywordsJSON}
                      isTopicPreview={false}
                      isHarmWatchTab={false}
                    />
                    {returnFeedCommentsModalBody()}
                  </div>
                    {returnModalFooter()}
                </div>
              </div>
            )}
          </div>
        </Modal>
      );
    }
    
    function returnFeedModalForHarmWatchTab() {
      return (
        <Modal handleClick={() => toggleFeedDetails(false)}>
          <div className={`modal feed-details-modal-harm-watch ${show ? 'modal-show' : 'modal-hide'}`}>
            {show && (
              <div className="modal-dialog">
                <div className="modal-content">
                <div className='row'>
                  <div className="col-sm-5">
                    <div className="feed-modal-harm-watch-left-column">
                      <div className="modal-header">
                        <h4
                          className="modal-title"
                          dangerouslySetInnerHTML={{ __html: feed.feedTitle }}
                          title={feed.feedTitle}
                        />
                      </div>
                      <div className="modal-body py-0">
                        <Feeds
                          feed={feed}
                          isFeedModal={true}
                          updateRelevanceFeed={e => updateRelevanceFeed(e)}
                          handleFeedDetails={() => handleFeedDetails()}
                          cookies={cookies}
                          topicKeywordsJSON={topicKeywordsJSON}
                          isTopicPreview={false}
                          isHarmWatchTab={true}
                        />
                        <ControversyIndicesGrid
                          feed={feed}
                        />
                        {feed && 
                          <PieChartForFeedModal
                            feed={feed} 
                          />}
                      </div>
                    </div>
                  </div>
                  
                  <div className='col-sm-7'>
                    <div className="modal-header">
                      <h4
                        className="modal-title"
                        dangerouslySetInnerHTML={{ __html: returnFeedTotalCommentsHeader() }}
                        title={returnFeedTotalCommentsHeader()}
                      />
                      <button className="modal-close-button" onClick={() => toggleFeedDetails(false)} onKeyDown={() => {}}>
                        <i className="la la-close modal-close" />
                      </button>
                    </div>
                    <div className="modal-body py-0">
                    {returnFeedCommentsModalBody()}
                    </div>
                      {returnModalFooter()}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal>
      );
    }

    
    return (
      isHarmWatchTab ? returnFeedModalForHarmWatchTab() : returnFeedModalForResonanceDashboard()
    );
  },
);

export default FeedDetails;



// WEBPACK FOOTER //
// ./src/features/home/components/feeds-detail-modal/Feeds-Detail-Modal.js